(() => {
  const root = document.querySelector('[data-buke-designer]');
  if (!root) return;
  const launch = root.querySelector('.buke-designer__launch');
  const dialog = root.querySelector('.buke-designer__dialog');
  const close = root.querySelector('.buke-designer__close');
  const frame = root.querySelector('iframe');
  const designerUrl = root.dataset.designerUrl;
  const productHandle = root.dataset.productHandle;
  const variantId = root.dataset.variantId;

  launch.addEventListener('click', () => {
    if (!designerUrl) { alert('设计器地址尚未配置，请联系商店管理员。'); return; }
    const url = new URL(designerUrl);
    url.searchParams.set('embed', 'shopify');
    url.searchParams.set('product_handle', productHandle);
    url.searchParams.set('variant_id', variantId);
    frame.src = url.toString();
    dialog.showModal();
  });
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

  window.addEventListener('message', async (event) => {
    if (!designerUrl || event.origin !== new URL(designerUrl).origin) return;
    const message = event.data;
    if (!message || message.type !== 'buke:add-to-cart') return;
    const design = message.design || {};
    if (!design.id || !design.previewUrl) { alert('设计文件尚未保存，请返回设计器后重试。'); return; }
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{
        id: Number(variantId), quantity: 1,
        properties: {
          '_BUKE Design ID': String(design.id),
          '设计预览': String(design.previewUrl),
          '鞋码': String(design.size || ''),
          '模板版本': String(design.templateVersion || ''),
          '生产状态': '待核价'
        }
      }] })
    });
    if (!response.ok) { alert('加入购物车失败，请稍后重试。'); return; }
    window.location.assign('/cart');
  });
})();
